import { Children, isValidElement } from "react";

import { Wheel, WheelContainer } from "./WheelContainer";
import { NodeContext, PathContext } from "@dashboard/contexts/pathContext";
import { YearNavigation } from "../YearNavigationSvg";

type CycleProps = {
    children: React.ReactNode;
    year?: number;
    onYearChange?: (newYear: number) => void;
};

export function Cycle({ children, year, onYearChange }: CycleProps) {
    const radius = 300 / 2.5;
    const arr = Children.toArray(children);
    const total = arr.length;
    const center = 300 / 2;

    return (
        <>
            <WheelContainer>
                <Wheel />
                <PathContext.Provider value={{ total }}>
                    {arr.map((child, index) => {
                        const angle = (index / arr.length) * 2 * Math.PI - Math.PI / 2;
                        const x = center + radius * Math.cos(angle);
                        const y = center + radius * Math.sin(angle);

                        return isValidElement(child) ? (
                            <NodeContext.Provider value={{ x: x, y: y }} key={child.key ?? index}>
                                {child}
                            </NodeContext.Provider>
                        ) : (
                            child
                        );
                    })}
                    {year && <YearNavigation year={year} onYearChange={onYearChange} />}{" "}
                </PathContext.Provider>
            </WheelContainer>
        </>
    );
}
